import { useTranslation } from "react-i18next";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";
import CategoryDropdown from "./CategoryDropdown";

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            {t("categories_title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-700">{t("categories_subtitle")}</p>
        </div>

        {/* Dropdown selector */}
        <div className="mt-8">
          <CategoryDropdown />
        </div>

        {/* Two main buttons */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-heading font-semibold text-base cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t("btn_usfans")}
            <i className="ri-external-link-line" />
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-accent-500 text-background-50 font-heading font-semibold text-base cursor-pointer hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            {t("btn_buy_now")}
            <i className="ri-shopping-bag-3-line" />
          </a>
        </div>

        {/* Category grid */}
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((c) => (
            <a
              key={c.slug}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden cursor-pointer hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-32 md:h-40 overflow-hidden">
                <img
                  src={c.image}
                  alt={t(`cats.${c.slug}`)}
                  title={`${t(`cats.${c.slug}`)} - USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 md:p-4 flex items-center justify-between gap-2">
                <span className="text-sm md:text-base font-medium text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">
                  {t(`cats.${c.slug}`)}
                </span>
                <span className="w-6 h-6 shrink-0 flex items-center justify-center text-primary-500">
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}